import { render, staticRenderFns } from "./GeneralPromotion.vue?vue&type=template&id=2128d213&"
import script from "./GeneralPromotion.vue?vue&type=script&lang=js&"
export * from "./GeneralPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports